import cx from 'classnames';
import IconLogo from '../IconLogo';
import Link from '../Link';

type LogoColumnProps = {
  invert?: boolean;
  isMobileMenuOpen: boolean;
  isHeaderScrolled: boolean;
}

export const LogoColumn = ({ invert, isMobileMenuOpen, isHeaderScrolled }: LogoColumnProps) =>
  <div className="lg:col-span-2 2xl:col-span-3 flex">
    <Link href="/" className="block">
      <IconLogo
        className={cx('w-[112px] h-[26px] transition-colors duration-300', {
          'text-white': invert && !isMobileMenuOpen && !isHeaderScrolled,
          'text-violet-900': !invert || isMobileMenuOpen || isHeaderScrolled,
        })}
      />
    </Link>
  </div>
